import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Wrench, Trophy, User, Tag, ShieldCheck } from 'lucide-react';
import './App.css';

function App() {
  // --- ESTADOS (Hooks) ---
  const [datos, setDatos] = useState(null);
  const [adminMode, setAdminMode] = useState(false);
  const [nuevoCliente, setNuevoCliente] = useState({ nombre: '', email: '' });
  const [cargando, setCargando] = useState(false);

  // --- COLORES CORPORATIVOS ---
  const rojoGuadalix = '#E64A33';
  const grisGuadalix = '#333333';

  // --- CARGAR DATOS AL INICIAR ---
  useEffect(() => {
    fetch('https://venpuntos-api.lmontoro.workers.dev/puntos')
      .then(res => res.json())
      .then(json => setDatos(json))
      .catch(err => console.error("Error al cargar:", err));
  }, []);

  // --- FUNCIÓN PARA REGISTRAR NUEVO CLIENTE ---
  const registrar = async () => {
    if (!nuevoCliente.nombre || !nuevoCliente.email) {
      alert("Por favor, rellena nombre y email");
      return;
    }
    setCargando(true);
    try {
      const res = await fetch('https://venpuntos-api.lmontoro.workers.dev/registro', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevoCliente)
      });
      if (res.ok) {
        alert("✅ ¡Cliente registrado con éxito en Guadalix!");
        setNuevoCliente({ nombre: '', email: '' });
        setAdminMode(false);
      } else {
        alert("Error al registrar");
      }
    } catch (error) {
      alert("Error de conexión");
    }
    setCargando(false);
  };

  return (
    <div className="App" style={{ backgroundColor: '#f4f4f4', minHeight: '100vh', color: grisGuadalix, fontFamily: 'sans-serif' }}>
      
      {/* CABECERA CON LOGO (FONDO BLANCO) */}
      <header style={{ backgroundColor: 'white', padding: '15px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <img 
          src={process.env.PUBLIC_URL + '/logo-guadalix.png'} 
          alt="Ferretería Guadalix" 
          style={{ width: '100%', maxWidth: '300px', height: 'auto', display: 'block', margin: '0 auto' }}
          onError={(e) => { e.target.style.display = 'none'; }} // Si no hay logo, no muestra icono roto
        />
      </header>

      <main style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
        
        {/* VISTA DE ADMINISTRACIÓN (PANTALLA DE REGISTRO) */}
        {adminMode ? (
          <div style={{ background: 'white', borderRadius: '20px', padding: '25px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderTop: `5px solid ${grisGuadalix}` }}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.2rem' }}>
              <ShieldCheck color={grisGuadalix} /> Registro de Cliente
            </h2>
            <div style={{ marginTop: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.8rem', fontWeight: 'bold' }}>Nombre Completo</label>
              <input 
                type="text"
                placeholder="Ej. Juan Pérez" 
                value={nuevoCliente.nombre}
                onChange={e => setNuevoCliente({...nuevoCliente, nombre: e.target.value})} 
                style={{ width: '100%', padding: '12px', marginBottom: '15px', borderRadius: '8px', border: '1px solid #ccc', boxSizing: 'border-box' }} 
              />
              
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.8rem', fontWeight: 'bold' }}>Correo Electrónico</label>
              <input 
                type="email"
                placeholder="juan@gmail.com" 
                value={nuevoCliente.email}
                onChange={e => setNuevoCliente({...nuevoCliente, email: e.target.value})} 
                style={{ width: '100%', padding: '12px', marginBottom: '20px', borderRadius: '8px', border: '1px solid #ccc', boxSizing: 'border-box' }} 
              />
              
              <button 
                onClick={registrar} 
                disabled={cargando}
                style={{ width: '100%', padding: '15px', borderRadius: '12px', border: 'none', backgroundColor: grisGuadalix, color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
              >
                {cargando ? 'GUARDANDO...' : 'DAR DE ALTA CLIENTE'}
              </button>
              
              <button 
                onClick={() => setAdminMode(false)} 
                style={{ width: '100%', marginTop: '10px', padding: '10px', background: 'none', border: 'none', color: '#666', fontSize: '0.9rem' }}
              >
                Cancelar
              </button>
            </div>
          </div>
        ) : (
          /* VISTA DEL CLIENTE (TARJETA DE PUNTOS) */
          <>
            <div style={{ background: 'white', borderRadius: '20px', padding: '25px', textAlign: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderTop: `5px solid ${rojoGuadalix}` }}>
              {datos ? (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '15px' }}>
                    <User size={20} color={rojoGuadalix} />
                    <span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: grisGuadalix }}>{datos.cliente}</span>
                  </div>

                  <div style={{ margin: '15px auto', padding: '10px', background: '#f9f9f9', borderRadius: '15px', display: 'inline-block' }}>
                    <QRCodeSVG value={`puntos:${datos.puntos}`} size={160} fgColor={grisGuadalix} />
                  </div>

                  <div style={{ marginTop: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                      <Trophy size={20} color={rojoGuadalix} />
                      <span style={{ fontSize: '0.9rem', color: '#666', fontWeight: 'bold' }}>MIS VENPUNTOS</span>
                    </div>
                    <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: rojoGuadalix }}>
                      {datos.puntos} <span style={{ fontSize: '1rem' }}>pts</span>
                    </div>
                  </div>
                </>
              ) : (
                <div style={{ padding: '40px' }}>
                  <Wrench size={40} color={rojoGuadalix} className="spin" />
                  <p>Cargando tus ventajas...</p>
                </div>
              )}
            </div>

            {/* SECCIÓN DE OFERTAS */}
            <div style={{ marginTop: '25px', textAlign: 'left' }}>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.1rem', color: grisGuadalix }}>
                <Tag size={20} color={rojoGuadalix} /> Ofertas Exclusivas
              </h3>
              
              {datos && datos.ofertas ? (
                datos.ofertas.map(oferta => (
                  <div key={oferta.id} style={{ background: 'white', padding: '15px', borderRadius: '15px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', borderLeft: `4px solid ${rojoGuadalix}` }}>
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '1rem' }}>{oferta.titulo}</div>
                      <div style={{ fontSize: '0.8rem', color: '#666' }}>{oferta.desc}</div>
                    </div>
                    <div style={{ backgroundColor: '#fff0ef', color: rojoGuadalix, fontWeight: 'bold', padding: '5px 10px', borderRadius: '8px', fontSize: '0.9rem' }}>
                      {oferta.dto}
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ background: '#fff', padding: '15px', borderRadius: '15px', border: '1px dashed #ccc', textAlign: 'center', color: '#999' }}>
                   No hay ofertas activas hoy.
                </div>
              )}
            </div>

            <button style={{ width: '100%', marginTop: '30px', padding: '18px', borderRadius: '15px', border: 'none', backgroundColor: rojoGuadalix, color: 'white', fontWeight: 'bold', fontSize: '1.1rem', boxShadow: '0 4px 10px rgba(230, 74, 51, 0.3)' }}>
              ESCANEAR EN TIENDA
            </button>

            {/* BOTÓN DISCRETO PARA EL DUEÑO */}
            <button 
              onClick={() => setAdminMode(true)} 
              style={{ width: '100%', marginTop: '40px', background: 'none', border: 'none', color: '#ccc', fontSize: '0.7rem', cursor: 'pointer' }}
            >
              ⚙️ ACCESO STAFF GUADALIX
            </button>
          </>
        )}
      </main>

      <footer style={{ textAlign: 'center', padding: '20px', opacity: 0.5, fontSize: '0.7rem' }}>
        Ferretería Guadalix &copy; 2026 - VenPuntos
      </footer>
    </div>
  );
}

export default App;